import { IAction } from "../../../../interface/action.interface";
import { IHistoricalSnapshotDto } from "../../interface/dto/historical-snapshots.dto";

export enum HistoricalSnapshotActionType {
    HISTORICAL_SNAPSHOT_GET = "HISTORICAL_SNAPSHOT_GET",
    HISTORICAL_SNAPSHOT_GET_SUCCESS = "HISTORICAL_SNAPSHOT_GET_SUCCESS",
    HISTORICAL_SNAPSHOT_GET_ERROR = "HISTORICAL_SNAPSHOT_GET_ERROR",
    HISTORICAL_SNAPSHOT_EXPORT_SUMMARY = "HISTORICAL_SNAPSHOT_EXPORT_SUMMARY",
}

export interface IHistoricalSnapshotGetAction extends IAction {
    type: HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET;
    payload: {
        listId: number;
    };
}

export interface IHistoricalSnapshotGetSuccessAction extends IAction {
    type: HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET_SUCCESS;
    payload: {
        historicalSnapshot: Array<IHistoricalSnapshotDto>;
    };
}

export interface IHistoricalSnapshotGetErrorAction extends IAction {
    type: HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET_ERROR;
    payload: {
        error: string;
    };
}

export interface IHistoricalSnapshotExportSummaryAction extends IAction {
    type: HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_EXPORT_SUMMARY;
}

export const historicalSnapshotGetAction = (
    listId: number,
): IHistoricalSnapshotGetAction => ({
    type: HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET,
    payload: {
        listId,
    },
});

export const historicalSnapshotGetSuccessAction = (
    historicalSnapshot: Array<IHistoricalSnapshotDto>,
): IHistoricalSnapshotGetSuccessAction => ({
    type: HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET_SUCCESS,
    payload: { historicalSnapshot },
});

export const historicalSnapshotGetErrorAction = (error: string) => ({
    type: HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET_ERROR,
    payload: { error },
});

export const historicalSnapshotExportSummaryAction =
    (): IHistoricalSnapshotExportSummaryAction => ({
        type: HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_EXPORT_SUMMARY,
        payload: {},
    });

export type IHistoricalSnapshotAction =
    | IHistoricalSnapshotGetAction
    | IHistoricalSnapshotGetSuccessAction
    | IHistoricalSnapshotGetErrorAction
    | IHistoricalSnapshotExportSummaryAction;
